import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL ?? '/api'
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('app-token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // IMPORTANT
  // remove json content type for FormData
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('app-token'); // ✅ FIXED
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
